import type { JobState, RunState } from '../types';

type ColorClass = string;

// Keyed by the canonical JobState | RunState union so the map is forced to
// cover every known state at compile time — this is what would have caught the
// old CANCELED/CANCELLED spelling drift. (REVIEW is job-only; the rest are
// shared by jobs and runs.) The component prop stays `string`: unknown states
// fall back to neutral so a server-added state still renders.
const STATE_COLORS: Record<JobState | RunState, ColorClass> = {
  QUEUED: 'bg-slate-100 text-slate-700 ring-slate-200',
  RUNNING: 'bg-blue-100 text-blue-800 ring-blue-200',
  REVIEW: 'bg-amber-100 text-amber-800 ring-amber-200',
  COMPLETED: 'bg-green-100 text-green-800 ring-green-200',
  FAILED: 'bg-red-100 text-red-800 ring-red-200',
  CANCELLED: 'bg-gray-100 text-gray-700 ring-gray-200',
};

const UNKNOWN: ColorClass = 'bg-slate-100 text-slate-600 ring-slate-200';

export function StateBadge({ state }: { state: string }) {
  const color = STATE_COLORS[state as JobState | RunState] ?? UNKNOWN;
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold uppercase tracking-wide ring-1 ${color}`}
    >
      {state}
    </span>
  );
}
